import Vue from 'vue';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

Vue.component('vuetify-google-autocomplete', VuetifyGoogleAutocomplete);
